import { Tween } from "@westpierstudio/luma/createjs";
import { Action } from "@westpierstudio/luma/utils/flow/Action";


export class MinTimeBetweenWagersAction extends Action {

    minTimeBetweenWagers: number;
    startTime: number;

    constructor(minTimeBetweenWagers:number) {
        super(minTimeBetweenWagers);
        this.minTimeBetweenWagers = minTimeBetweenWagers;
        this.startTime = Date.now();
    }

    run() {
        const currentTime = Date.now();
        const elapsedTime = currentTime - this.startTime;
        if (elapsedTime >= this.minTimeBetweenWagers) {
            console.log(`minTimeBetweenWagers (${this.minTimeBetweenWagers}ms) already elapsed`);
            this.complete();
        } else {
            const remaining = this.minTimeBetweenWagers - elapsedTime;
            console.warn(`minTimeBetweenWagers delay - elapsedTime ${elapsedTime}ms - wait ${remaining}ms - for a total minTimeBetweenWagers of ${this.minTimeBetweenWagers}ms`);
            Tween.get(this)
                .wait(remaining)
                .call(() => this.complete());
        }
    }

    destroy(): void {
        Tween.removeTweens(this);
    }

    override toString() {
        const args = this.getArguments();
        return `DelayAction ${args[0]}ms`;
    }
}